/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CategoryArticleMappingDto = {
    id: number;
    categoryId: number;
    /**
     * The accounting provider type this mapping is for
     */
    providerType: string;
    /**
     * The type of mapping: category (main price) or outage_fee (Ausfallhonorar)
     */
    mappingType: CategoryArticleMappingDto.mappingType;
    externalArticleId: string;
    externalArticleName: string;
    externalArticlePrice: string;
    externalArticleTaxRate: string;
    externalArticleUnit?: string | null;
    /**
     * Quantity of this article to include on invoices
     */
    quantity: string;
    createdAt: string;
    updatedAt: string;
};
export namespace CategoryArticleMappingDto {
    /**
     * The type of mapping: category (main price) or outage_fee (Ausfallhonorar)
     */
    export enum mappingType {
        CATEGORY = 'category',
        OUTAGE_FEE = 'outage_fee',
    }
}

